class SkindexPreferences {
  constructor() {
    this.config = window.acon_skinko_config_skindex || {};
    this.preferences = {};
    this.options = {};
    this.sections = [
      'skin_type', 'skin_concerns', 'skin_tone', 'fav_ingredients',
      'family_fragance', 'hair_type', 'hair_texture', 'hair_concerns',
      'hair_color', 'fav_brand', 'eye_color', 'age_range'
    ];
    this.multiSelectSections = ['skin_type', 'skin_concerns', 'fav_ingredients', 'family_fragance', 'hair_type', 'hair_texture', 'hair_concerns', 'fav_brand'];
    this.searchSections = ['fav_ingredients', 'fav_brand'];
    this.DEBUG = false;
  }

  log(message, data) {
    if (this.DEBUG) {
      console.log(`[${new Date().toISOString()}] ${message}`, data ? JSON.stringify(data, null, 2) : '');
    }
  }

  validateConfig() {
  
    const required = ['appProxyUrl', 'customerId', 'shopDomain', 'jwtSecret'];
    const missing = required.filter(key => !this.config[key]);

    if (!this.config.customerLoggedIn) {
      return false;
    }

    if (missing.length > 0) {
      this.log(`Config validation error: Missing ${missing.join(', ')}`);
      throw new Error(`Configuración faltante: ${missing.join(', ')}`);
    }
  }

  async init() {
    const container = document.querySelector('.skindex-container');
    if (!container) {
      this.log('Skindex container not found');
      return;
    }
    try {
      this.validateConfig();
    } catch (error) {
      this.log('Config validation error', { message: error.message });
      container.innerHTML = '<p>Error de configuración. Contacta al soporte.</p>';
      return;
    }
    if (!this.config.customerLoggedIn) {
      this.log('User not logged in, showing login message');
      this.showLoginMessage();
      return;
    }
    try {
      await this.loadPreferences();
      await this.loadProductOptions();
      await this.loadProductOptions();
      await this.fetchRecommendations();
      this.loadOptionsFromContainer();
      this.cleanSearchInputs();
      this.setupEventListeners();
      this.updateProgressBar();
      this.debugDOM();
      this.openFirstEmptySection();
      if (this.sections.every(section => this.preferences[section] && (Array.isArray(this.preferences[section]) ? this.preferences[section].length > 0 : true))) {
        this.showCompletionMessage();
      }
    } catch (error) {
      this.log('Initialization error', { message: error.message, stack: error.stack });
      //this.showError('Error al inicializar las preferencias. Intenta de nuevo.');
    }
  }

  async loadProductOptions() {
    try {
        const response = await fetch(`${this.config.appProxyUrl}/options`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${this.config.jwtSecret}`,
            'Content-Type': 'application/json'
        }
        });
        if (!response.ok) {
        const errorData = await response.json();
        this.log('Error fetching shopify.constitutive-ingredients and custom.brand', { status: response.status, statusText: response.statusText, errorData });
        throw new Error(errorData.error || `HTTP error: ${response.status}`);
        }
        const optionsData = await response.json();

        // Process shopify.constitutive-ingredients
        let ingredients = (optionsData.ingredients || []).filter(name => 
        typeof name === 'string' && name.trim() && !name.includes('gid://shopify/Metaobject')
        );
        if (ingredients.length === 0) {
        this.log('No valid ingredients received from worker, using fallback', optionsData.ingredients);
        ingredients = ['Niacinamide', 'Retinol', 'Hyaluronic Acid', 'Vitamin C']; // Fallback list
        }
        this.options.fav_ingredients = ingredients.map((name, index) => {
        return { name: name.trim(), image: '' };
        });

        const brands = (optionsData.brands || []).filter(name => 
        typeof name === 'string' && name.trim()
        );
        this.options.fav_brand = brands.map((name, index) => {
        return { name: name.trim(), image: '' };
        });

        localStorage.setItem('skindex_product_options', JSON.stringify({
        fav_ingredients: this.options.fav_ingredients,
        fav_brand: this.options.fav_brand
        }));
    } catch (error) {
        this.log('Error processing shopify.constitutive-ingredients and custom.brand from worker', { message: error.message, stack: error.stack });
        this.options.fav_ingredients = [
        { name: 'Niacinamide', image: '' },
        { name: 'Retinol', image: '' },
        { name: 'Hyaluronic Acid', image: '' },
        { name: 'Vitamin C', image: '' }
        ];
        this.options.fav_brand = [];
        this.showError('Error al cargar datos de ingredientes y marcas. Usando lista predeterminada.');
    }
    }
  
  async fetchRecommendations() {
    if (!this.config.customerLoggedIn || !this.config.customerId) {
        this.log('Skipping recommendations: No customer logged in');
        return;
    }

    try {
        const response = await fetch(`${this.config.appProxyUrl}/recommendations`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${this.config.jwtSecret}`
        },
        body: JSON.stringify({ customerId: this.config.customerId })
        });

        if (!response.ok) {
        const errorData = await response.json();
        this.log('Error fetching recommendations', { status: response.status, statusText: response.statusText, errorData });
        throw new Error(errorData.error || `HTTP error: ${response.status}`);
        }

        const data = await response.json();

        if (data.error) {
        this.log('Error in recommendations response', data.error);
        return;
        }

        this.renderRecommendations(data.products || []);
    } catch (error) {
        this.log('Error fetching recommendations', { message: error.message, stack: error.stack });
        this.showError('Error al cargar recomendaciones personalizadas.');
    }
    }

renderRecommendations(products) {
  const picksList = document.querySelector('.picks-list');
  const personalizedPicks = document.getElementById('personalized-picks');
  if (!picksList || !personalizedPicks) return;

  picksList.innerHTML = '';
  if (products.length === 0) {
    personalizedPicks.style.display = 'none';
    return;
  }

  personalizedPicks.style.display = 'block';
  products.forEach(product => {
    const li = document.createElement('li');
    li.innerHTML = `
      <a href="/products/${product.handle}">
        <img src="${product.image}" alt="${product.title}">
        <p>${product.title} - ${product.brand}</p>
        <p>${product.price} ${product.currency}</p>
      </a>
    `;
    picksList.appendChild(li);
  });
}

  openFirstEmptySection() {
    const firstEmptySection = this.sections.find(section => 
      !this.preferences[section] || 
      (Array.isArray(this.preferences[section]) && this.preferences[section].length === 0)
    );
    if (firstEmptySection) {
      this.toggleSection(firstEmptySection);
    } else {
      this.log('No empty sections found');
    }
  }
    debugDOM() {
    this.sections.forEach(section => {
        const btn = document.querySelector(`.section-toggle[data-section="${section}"]`);
        const content = document.querySelector(`.section-content[data-section="${section}"]`);
        const actions = document.querySelector(`.action-buttons[data-section="${section}"]`);
        const search = document.querySelector(`.search-container[data-section="${section}"]`);
        const options = document.querySelector(`.section-options[data-section="${section}"]`);
    });
    }

  cleanSearchInputs() {
    this.sections.forEach(section => {
      if (!this.searchSections.includes(section)) {
        const searchContainer = document.querySelector(`.search-container[data-section="${section}"]`);
        if (searchContainer) {
          this.log(`Removing invalid search container for ${section}`);
          searchContainer.remove();
        }
      }
    });
  }

  loadOptionsFromContainer() {
    const container = document.querySelector('.skindex-container');
    if (!container || !container.dataset.rawBeautyOptions) {
      this.log('Missing container or dataset.rawBeautyOptions', {
        container: !!container,
        rawBeautyOptions: !!container?.dataset.rawBeautyOptions
      });
      this.showError('No se encontraron opciones. Verifica la configuración.');
      return;
    }
    try {
      let beautyOptions = {};
      try {
        beautyOptions = JSON.parse(container.dataset.rawBeautyOptions.replace(/&quot;/g, '"'));
      } catch (error) {
        this.log('Error parsing raw beauty options', { message: error.message });
        beautyOptions = {};
      }

      this.sections.forEach(section => {
        const optionsContainer = document.querySelector(`.section-options[data-section="${section}"]`);
        if (!optionsContainer) {
          this.log(`Options container not found for ${section}`);
          return;
        }
        const isMultiSelect = this.multiSelectSections.includes(section);
        const isSearchSection = this.searchSections.includes(section);
        const currentValues = this.preferences[section] || (isMultiSelect ? [] : null);

        let sectionOptions = [];
        if (isSearchSection) {
          sectionOptions = (section === 'fav_brand' ? this.options.fav_brand : this.options.fav_ingredients) || [];
        } else {
          sectionOptions = Array.isArray(beautyOptions[section]) ? beautyOptions[section].filter(opt => 
            opt && opt.name && typeof opt.name === 'string' && opt.name !== '' && 
            !opt.name.includes('gid://shopify/Metaobject') && !opt.name.includes('[]')
          ) : [];
          this.options[section] = sectionOptions;
        }

        let html = '';
        if (isSearchSection) {
          const datalistId = `${section}-suggestions`;
          html = `<ul class="${section}-list" style="display: none;">`;
          sectionOptions.forEach(opt => {
            const isSelected = currentValues.includes(opt.name) ? 'selected' : '';
            html += `<li class="${isSelected}" data-value="${opt.name.replace(/"/g, '&quot;')}">${opt.name}</li>`;
          });
          html += `</ul>`;
        } else {
          html = sectionOptions.length > 0 
            ? sectionOptions.map(opt => `
                <div class="option-item">
                  <label class="option-label">
                    <input type="${isMultiSelect ? 'checkbox' : 'radio'}" 
                           name="${section}${isMultiSelect ? '[]' : ''}" 
                           value="${opt.name.replace(/"/g, '&quot;')}" 
                           class="option-input" 
                           data-section="${section}"
                           ${isMultiSelect && currentValues.includes(opt.name) || currentValues === opt.name ? 'checked' : ''}>
                    <div class="option-text">
                      ${opt.image && opt.image !== '' ? `<img src="${opt.image.replace(/"/g, '&quot;')}" alt="${opt.name.replace(/"/g, '&quot;')}" class="option-icon">` : ''}
                      <span class="option-text-inner">${opt.name}</span>
                    </div>
                  </label>
                </div>
              `).join('')
            : `<p>No hay opciones disponibles para ${section.replace(/_/g, ' ').toLowerCase()}. ${isSearchSection ? 'Usa el campo de búsqueda para añadir una opción.' : 'Contacta al administrador.'}</p>`;
        }

        optionsContainer.innerHTML = html;

        if (isSearchSection) {
          this.attachListEventListeners(section);
        }
      });
    } catch (error) {
      this.log('Error in loadOptionsFromContainer', { message: error.message, stack: error.stack });
      this.showError('Error al cargar las opciones. Verifica la configuración.');
      this.options = {};
      this.sections.forEach(section => { this.options[section] = []; });
    }
  }

  attachListEventListeners(section) {
    const listItems = document.querySelectorAll(`.section-options[data-section="${section}"] .${section}-list li`);
    listItems.forEach(item => {
      item.addEventListener('click', () => {
        const value = item.dataset.value;
        const currentPreferences = this.preferences[section] || [];
        if (currentPreferences.includes(value)) {
          this.preferences[section] = currentPreferences.filter(v => v !== value);
          item.classList.remove('selected');
        } else {
          this.preferences[section] = [...currentPreferences, value];
          item.classList.add('selected');
        }
        this.updateSavedValues(section);
        this.updateProgressBar();
      });
    });
  }

  async validateAndSaveSection(section, values) {
    if (!this.searchSections.includes(section)) {
      return values;
    }
    const validOptions = this.options[section].map(opt => opt.name);
    let validatedValues = [];
    if (Array.isArray(values)) {
      validatedValues = values.filter(val => validOptions.includes(val));
    } else if (validOptions.includes(values)) {
      validatedValues = values;
    }
    return validatedValues;
  }

  setupEventListeners() {
    const container = document.querySelector('.skindex-container');
    if (!container) {
      this.log('Container not found for event listeners');
      return;
    }

    this.searchSections.forEach(section => {
        const searchInput = document.querySelector(`.search-input[data-section="${section}"]`);
        if (searchInput) {
        searchInput.setAttribute('autocomplete', 'off');
        }
    });

    container.addEventListener('click', (e) => {
      const toggleBtn = e.target.closest('.section-toggle');
      if (toggleBtn) {
        const section = toggleBtn.dataset.section;
        this.toggleSection(section);
      }
      const saveBtn = e.target.closest('.save-section-btn');
      if (saveBtn) {
        const section = saveBtn.dataset.section;
        this.saveSection(section);
      }
      const skipBtn = e.target.closest('.skip-section-btn');
      if (skipBtn) {
        const section = skipBtn.dataset.section;
        this.skipSection(section);
      }
      const showAllBtn = e.target.closest('.show-all-btn');
      if (showAllBtn) {
        const section = showAllBtn.dataset.section;
        if (!this.searchSections.includes(section)) {
          return;
        }
        this.showAllOptions(section);
      }
      const addOptionBtn = e.target.closest('.add-option-btn');
      if (addOptionBtn) {
        const section = addOptionBtn.dataset.section;
        if (!this.searchSections.includes(section)) {
          this.log(`Add option not allowed for section: ${section}`);
          return;
        }
        this.addOption(section);
      }
    });

    container.addEventListener('input', (e) => {
      const optionInput = e.target.closest('.option-input');
      if (optionInput) {
        const section = optionInput.dataset.section;
        this.updatePreferences(section);
      }
      const searchInput = e.target.closest('.search-input');
      if (searchInput) {
        const section = searchInput.dataset.section;
        if (!this.searchSections.includes(section)) {
          return;
        }
        this.filterOptions(section, searchInput.value);
      }
    });
  }

  toggleSection(section) {
    this.sections.forEach(s => {
      const btn = document.querySelector(`.section-toggle[data-section="${s}"]`);
      const content = document.querySelector(`.section-content[data-section="${s}"]`);
      const actions = document.querySelector(`.action-buttons[data-section="${s}"]`);
      if (!btn || !content || !actions) {
        this.log(`Missing elements for section ${s}`, {
          btn: !!btn,
          content: !!content,
          actions: !!actions
        });
        return;
      }
      if (s === section) {
        const isExpanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !isExpanded);
        content.style.display = isExpanded ? 'none' : 'block';
        actions.style.display = isExpanded ? 'none' : 'flex';
      } else {
        btn.setAttribute('aria-expanded', 'false');
        content.style.display = 'none';
        actions.style.display = 'none';
      }
    });
  }

  updatePreferences(section) {
    if (this.searchSections.includes(section)) {
      // Preferences for search sections are updated via list item clicks
      return;
    }
    const inputs = document.querySelectorAll(`input[name="${section}[]"]:checked, input[name="${section}"]:checked`);
    if (this.multiSelectSections.includes(section)) {
      this.preferences[section] = Array.from(inputs).map(input => input.value).filter(val => val);
    } else {
      this.preferences[section] = inputs.length > 0 ? inputs[0].value : null;
    }
    this.updateSavedValues(section);
    this.updateProgressBar();
  }

  updateSavedValues(section) {
    const savedValuesDiv = document.querySelector(`.saved-values[data-section="${section}"]`);
    const selectedItemsDiv = document.querySelector(`.selected-items[data-section="${section}"]`);
    if (!savedValuesDiv) {
      return;
    }
    const values = this.preferences[section];
    if (!values || (Array.isArray(values) && values.length === 0)) {
      savedValuesDiv.style.display = 'none';
      savedValuesDiv.innerHTML = '';
      if (selectedItemsDiv) {
        selectedItemsDiv.style.display = 'none';
        selectedItemsDiv.innerHTML = '';
      }
      return;
    }
    const isMultiSelect = this.multiSelectSections.includes(section);
    const text = isMultiSelect ? values.join(' - ') : values;
    savedValuesDiv.innerHTML = `
      <svg class="checkmark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
      <span class="saved-text">${text}</span>
    `;
    savedValuesDiv.style.display = 'flex';
    if (this.searchSections.includes(section) && selectedItemsDiv) {
      selectedItemsDiv.style.display = 'block';
      selectedItemsDiv.innerHTML = values.map(value => `
        <span class="selected-item">
          ${value}
          <span class="remove-item" data-value="${value.replace(/"/g, '&quot;')}">x</span>
        </span>
      `).join('');
      // Add event listener for remove buttons
      selectedItemsDiv.querySelectorAll('.remove-item').forEach(removeBtn => {
            removeBtn.addEventListener('click', (e) => {
              e.stopPropagation(); // Prevent triggering the parent li click
              const value = removeBtn.dataset.value;
              this.preferences[section] = (this.preferences[section] || []).filter(v => v !== value);
              this.updateSavedValues(section); // Recursively update to reflect change
              this.updateProgressBar();
            });
          });
        } else if (selectedItemsDiv) {
          selectedItemsDiv.style.display = 'none';
          selectedItemsDiv.innerHTML = '';
        }
      }

  updateProgressBar() {
    const completed = this.sections.filter(section => this.preferences[section] && (Array.isArray(this.preferences[section]) ? this.preferences[section].length > 0 : true)).length;
    const progress = (completed / this.sections.length) * 100;
    const progressBar = document.getElementById('progress-bar');
    if (progressBar) {
      progressBar.style.width = `${progress}%`;
    } else {
      this.log('Progress bar element not found');
    }
    if (completed === this.sections.length) {
      this.showCompletionMessage();
    }
  }

  filterOptions(section, query) {
    if (!this.searchSections.includes(section)) {
      this.log(`Search not allowed for section: ${section}`);
      return;
    }
    const optionsContainer = document.querySelector(`.section-options[data-section="${section}"]`);
    if (!optionsContainer) {
      this.log(`Options container not found for ${section}`);
      return;
    }
    const sectionOptions = (section === 'fav_brand' ? this.options.fav_brand : this.options.fav_ingredients) || [];
    let html = `<ul class="${section}-list" style="display: ${query.trim() ? 'block' : 'none'};">`;
    if (query.trim()) {
      const filteredOptions = sectionOptions
        .filter(opt => opt.name.toLowerCase().includes(query.toLowerCase()))
        .slice(0, 9); // Limit to 9 options
      filteredOptions.forEach(opt => {
        const isSelected = this.preferences[section]?.includes(opt.name) ? 'selected' : '';
        html += `<li class="${isSelected}" data-value="${opt.name.replace(/"/g, '&quot;')}">${opt.name}</li>`;
      });
    }
    html += `</ul>`;
    optionsContainer.innerHTML = html;
    this.attachListEventListeners(section);
  }

  showAllOptions(section) {
    if (!this.searchSections.includes(section)) {
      this.log(`Show all not allowed for section: ${section}`);
      return;
    }
    const optionsContainer = document.querySelector(`.section-options[data-section="${section}"]`);
    if (!optionsContainer) {
      this.log(`Options container not found for ${section}`);
      return;
    }
    const sectionOptions = (section === 'fav_brand' ? this.options.fav_brand : this.options.fav_ingredients) || [];
    const itemsPerPage = 15;
    const currentPage = parseInt(optionsContainer.dataset.page || '1', 10);
    const totalPages = Math.ceil(sectionOptions.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedOptions = sectionOptions.slice(startIndex, startIndex + itemsPerPage);

    let html = `<ul class="${section}-list two-column" style="display: block;">`;
    paginatedOptions.forEach(opt => {
      const isSelected = this.preferences[section]?.includes(opt.name) ? 'selected' : '';
      html += `<li class="${isSelected}" data-value="${opt.name.replace(/"/g, '&quot;')}">${opt.name}</li>`;
    });
    html += `</ul>`;
    if (totalPages > 1) {
      html += `
        <div class="pagination">
          <button class="prev-page" data-section="${section}" ${currentPage === 1 ? 'disabled' : ''}>Anterior</button>
          <span>Página ${currentPage} de ${totalPages}</span>
          <button class="next-page" data-section="${section}" ${currentPage === totalPages ? 'disabled' : ''}>Siguiente</button>
        </div>
      `;
    }
    optionsContainer.innerHTML = html;
    const searchInput = document.querySelector(`.search-input[data-section="${section}"]`);
    if (searchInput) {
      searchInput.value = '';
    }
    optionsContainer.dataset.page = currentPage;
    this.attachListEventListeners(section);
    this.attachPaginationListeners(section);
  }

  attachPaginationListeners(section) {
    const prevButton = document.querySelector(`.prev-page[data-section="${section}"]`);
    const nextButton = document.querySelector(`.next-page[data-section="${section}"]`);
    const optionsContainer = document.querySelector(`.section-options[data-section="${section}"]`);
    if (!optionsContainer) return;

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        const currentPage = parseInt(optionsContainer.dataset.page || '1', 10);
        if (currentPage > 1) {
          optionsContainer.dataset.page = currentPage - 1;
          this.showAllOptions(section);
        }
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        const sectionOptions = (section === 'fav_brand' ? this.options.fav_brand : this.options.fav_ingredients) || [];
        const totalPages = Math.ceil(sectionOptions.length / 15);
        const currentPage = parseInt(optionsContainer.dataset.page || '1', 10);
        if (currentPage < totalPages) {
          optionsContainer.dataset.page = currentPage + 1;
          this.showAllOptions(section);
        }
      });
    }
  }

  addOption(section) {
    if (!this.searchSections.includes(section)) {
      this.log(`Add option not allowed for section: ${section}`);
      return;
    }
    const searchInput = document.querySelector(`.search-input[data-section="${section}"]`);
    const optionsContainer = document.querySelector(`.section-options[data-section="${section}"]`);
    if (!searchInput || !optionsContainer) {
      this.log(`Search input or options container not found for ${section}`);
      return;
    }
    const value = searchInput.value.trim();
    if (!value) {
      this.log(`Empty search input for section: ${section}`);
      return;
    }
    const sectionOptions = (section === 'fav_brand' ? this.options.fav_brand : this.options.fav_ingredients) || [];
    const existingOption = sectionOptions.some(opt => opt.name === value);
    if (!existingOption) {
      sectionOptions.push({ name: value, image: '' });
      this.options[section] = sectionOptions;
    }
    // Auto-select the added or existing option
    const currentPreferences = this.preferences[section] || [];
    if (!currentPreferences.includes(value)) {
      this.preferences[section] = [...currentPreferences, value];
      this.log(`Auto-selected option for ${section}`, { value });
    }
    let html = `<ul class="${section}-list" style="display: block;">`;
    sectionOptions.forEach(opt => {
      const isSelected = this.preferences[section]?.includes(opt.name) ? 'selected' : '';
      html += `<li class="${isSelected}" data-value="${opt.name.replace(/"/g, '&quot;')}">${opt.name}</li>`;
    });
    html += `</ul>`;
    optionsContainer.innerHTML = html;
    searchInput.value = '';
    this.attachListEventListeners(section);
    this.updateSavedValues(section);
    this.updateProgressBar();
  }

  async saveSection(section) {
    this.updatePreferences(section);
    let values = this.preferences[section];
    
    if (this.multiSelectSections.includes(section)) {
      if (!Array.isArray(values) || values.length === 0) {
        this.toggleSection(section);
        this.nextSection(section);
        return;
      }
      values = await this.validateAndSaveSection(section, values);
      if (values.length === 0) {
        this.log(`No valid values to save for ${section} after validation`);
        this.toggleSection(section);
        this.nextSection(section);
        return;
      }
      values = JSON.stringify(values);
    } else {
      if (!values) {
        this.toggleSection(section);
        this.nextSection(section);
        return;
      }
      values = await this.validateAndSaveSection(section, values);
      if (!values) {
        this.log(`No valid value to save for ${section} after validation`);
        this.toggleSection(section);
        this.nextSection(section);
        return;
      }
    }
    
    const options = Array.isArray(this.options[section]) ? this.options[section].map(opt => opt.name) : [];

    try {
    const response = await fetch(`${this.config.appProxyUrl}/save`, {
        method: 'POST',
        headers: {
        'Authorization': `Bearer ${this.config.jwtSecret}`,
        'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        customerId: this.config.customerId,
        section,
        values,
        options
        })
    });
    if (!response.ok) {
        const errorData = await response.json();
        this.log(`Error saving section ${section}`, { status: response.status, statusText: response.statusText, errorData });
        throw new Error(errorData.error || `HTTP error: ${response.status}`);
    }
    await this.fetchRecommendations();
    this.toggleSection(section);
    this.nextSection(section);
    } catch (error) {
      this.log('Error in saveSection', { message: error.message, stack: error.stack });
      this.showError(`Error al guardar: ${error.message}`);
      this.toggleSection(section);
      this.nextSection(section);
    }
  }

  skipSection(section) {
    this.log(`Skipping section: ${section}`);
    this.preferences[section] = null;
    this.updateSavedValues(section);
    this.toggleSection(section);
    this.nextSection(section);
  }

  nextSection(currentSection) {
    const currentIndex = this.sections.indexOf(currentSection);
    if (currentIndex === -1) {
      this.log(`Section ${currentSection} not found`);
      return;
    }
    const allCompleted = this.sections.every(section => 
      this.preferences[section] && (Array.isArray(this.preferences[section]) ? this.preferences[section].length > 0 : true)
    );
    if (allCompleted) {
      this.showCompletionMessage();
      return;
    }
    if (currentIndex < this.sections.length - 1) {
      const nextSection = this.sections[currentIndex + 1];
      this.toggleSection(nextSection);
    }
  }

    async showCompletionMessage() {
        const picksContainer = document.getElementById('personalized-picks');
        if (picksContainer) {
            picksContainer.style.display = 'block';
            await this.fetchRecommendations(); // Use fetchRecommendations instead
        }
    }

  async loadPersonalizedPicks() {
    try {
      const keywords = this.generateKeywords();
      const query = [
        ...keywords,
        ...(this.preferences.fav_ingredients || []).map(i => `tag:${i.toLowerCase()}`),
        ...(this.preferences.fav_brand || []).map(b => `tag:${b.toLowerCase()}`)
      ].join(' OR ');
      const storeQuery = `
        query {
          products(first: 100, query: "${query}") {
            edges {
              node {
                id
                title
                handle
                featuredImage {
                  url
                  altText
                }
                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }
                metafields(first: 10, namespace: "shopify") {
                  edges {
                    node {
                      namespace
                      key
                      value
                      type
                      reference @include(if: true) {
                        ... on Metaobject {
                          fields {
                            key
                            value
                          }
                        }
                      }
                    }
                  }
                }
                brand: metafield(namespace: "custom", key: "brand") {
                  namespace
                  key
                  value
                  type
                }
              }
            }
          }
        }
      `;
      this.log('Sending Storefront API query for personalized picks', { query: storeQuery });
      const response = await fetch(`https://${this.config.shopDomain}/api/2024-04/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query: storeQuery })
      });
      this.log('Storefront API response status', { status: response.status, statusText: response.statusText });
      if (!response.ok) {
        const errorText = await response.text();
        this.log('Storefront API error response', { errorText });
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      this.log('Storefront API response for personalized picks', data);
      let products = data.data.products.edges.map(edge => edge.node);
      if (this.preferences.fav_ingredients && this.preferences.fav_ingredients.length > 0) {
        products = products.filter(product => {
          const ingredients = product.metafields.edges
            .filter(edge => edge.node.namespace === 'shopify' && edge.node.key === 'constitutive-ingredients' && edge.node.type === 'metaobject_reference')
            .flatMap(edge => {
              if (edge.node.reference && edge.node.reference.fields) {
                const nameField = edge.node.reference.fields.find(field => field.key === 'name');
                return nameField && nameField.value ? [nameField.value.trim()] : [];
              }
              return [];
            });
          return this.preferences.fav_ingredients.some(i => ingredients.includes(i));
        });
      }
      if (this.preferences.fav_brand && this.preferences.fav_brand.length > 0) {
        products = products.filter(product => {
          const brandMatch = product.brand && product.brand.value && this.preferences.fav_brand.includes(product.brand.value);
          return brandMatch;
        });
      }
      products = products.slice(0, 7);
      const picksList = document.querySelector('.picks-list');
      if (!picksList) {
        this.log('Picks list not found');
        return;
      }
      picksList.innerHTML = products.map((product, index) => `
        <li class="${index === 0 || index === products.length - 1 ? 'hidden-placeholder' : ''}">
          <a href="/products/${product.handle}">
            <img src="${product.featuredImage?.url || ''}" alt="${product.featuredImage?.altText || product.title}" loading="lazy">
            <p>${product.title}</p>
            <p>${product.priceRange.minVariantPrice.amount} ${product.priceRange.minVariantPrice.currencyCode}</p>
          </a>
        </li>
      `).join('');
    } catch (error) {
      this.log('Error loading personalized picks', { message: error.message, stack: error.stack });
      this.showError('Error al cargar las recomendaciones personalizadas.');
    }
  }

  generateKeywords() {
    const keywords = [];
    this.sections.forEach(section => {
      if (section === 'fav_ingredients' || section === 'fav_brand') return;
      const values = this.preferences[section];
      if (values) {
        if (Array.isArray(values)) {
          values.forEach(val => {
            if (val && typeof val === 'string' && val.trim()) {
              keywords.push(val.toLowerCase());
            }
          });
        } else if (typeof values === 'string' && values.trim()) {
          keywords.push(values.toLowerCase());
        }
      }
    });
    const result = Array.from(new Set(keywords)).map(k => `tag:${k}`);
    return result;
  }

  showLoginMessage() {
    const container = document.querySelector('.skindex-container');
    if (container) {
      container.innerHTML = '<p>Por favor, inicia sesión para gestionar tus preferencias de belleza.</p>';
    } else {
      this.log('Skindex container not found for login message');
    }
  }

  async loadPreferences() {
    try {
      const response = await fetch(`${this.config.appProxyUrl}/get?customerId=${this.config.customerId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${this.config.jwtSecret}`,
          'Content-Type': 'application/json'
        }
      });
      if (!response.ok) {
        const errorData = await response.json();
        this.log('Error fetching preferences', { status: response.status, statusText: response.statusText, errorData });
        throw new Error(errorData.error || `HTTP error: ${response.status}`);
      }
      const preferences = await response.json();
      this.sections.forEach(section => {
        if (preferences[section] && this.multiSelectSections.includes(section)) {
          try {
            this.preferences[section] = JSON.parse(preferences[section]);
          } catch {
            this.preferences[section] = preferences[section].split(',').filter(v => v.trim());
          }
        } else {
          this.preferences[section] = preferences[section] || null;
        }
        this.updateSavedValues(section);
      });
    } catch (error) {
      this.log('Error in loadPreferences', { message: error.message, stack: error.stack });
      this.preferences = {};
      this.showError(`Error al cargar las preferencias: ${error.message}`);
    }
  }

  showError(message) {
    const container = document.querySelector('.skindex-container');
    if (!container) {
      this.log('Skindex container not found for error message');
      return;
    }
    const errorDiv = document.createElement('div');
    errorDiv.className = 'error-message';
    errorDiv.textContent = message;
    container.prepend(errorDiv);
    setTimeout(() => errorDiv.remove(), 5000);
    this.log('Displayed error message', { message });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.acon_skinko_config_skindex) {
    const skindex = new SkindexPreferences();
    skindex.init();
  }
});